import { app } from '../../../../app';

app.factory('RecoverySettingsService', RecoverySettingsService);

/** @ngInject */
function RecoverySettingsService($resource) {
    var updateSettings = $resource('app/rest/recovery/update_recovery', {}, {});
    var removeRecovery = $resource('app/rest/recovery/remove_recovery', {}, {});
    var turnOffRecovery = $resource('app/rest/recovery/turn_off', {}, {});
    var changeRecoveryReminder = $resource('app/rest/recovery/change_recovery_reminder', {}, {});
    var setRecoveryNumber = $resource('app/rest/recovery/userPhoneNumber/:phoneNumberId/setRecoveryNumber', {
        phoneNumberId : '@phoneNumberId'
    }, {});

    return {
        updateSettings : updateSettings,
        removeRecovery : removeRecovery,
        turnOffRecovery : turnOffRecovery,
        changeRecoveryReminder : changeRecoveryReminder,
        setRecoveryNumber : setRecoveryNumber
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/recovery-settings/recovery-settings.service.js